import React, { ErrorInfo } from "react";
import APIFailurePopup from "./components/CustomAPIFailurePopup/APIFailurePopup";
interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
  errorMessage: {
    msg?: string;
    stk?: string;
    // componentStack?: string;
  } | null;
}
class ErrorBoundary extends React.Component<Props, State> {
  // Constructor for initializing Variables etc in a state
  // Just similar to initial line of useState if you are familiar
  // with Functional Components
  constructor(props: Props) {
    super(props);
    this.state = { error: null, errorMessage: null };
  }

  retryPageLoading = () => {
    console.log("Retrying page load...");

    const alreadyReloaded = JSON.parse(
      localStorage.getItem("ForceReloadOnce") || "false",
    ) as boolean;

    if (!alreadyReloaded) {
      localStorage.setItem("ForceReloadOnce", "true");
      window.location.reload();
    } else {
      localStorage.removeItem("ForceReloadOnce");
      console.warn("Chunk reload attempt prevented to avoid loop.");
    }
  };

  clearError = () => {
    this.setState({ error: null, errorMessage: null });
  };

  private handleChunkError = async () => {
    console.log("Chunk load error detected — clearing cache & SW...");
    try {
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          await reg.unregister();
        }
        console.log("Service workers unregistered.");
      }
    } catch (err) {
      console.warn("Service worker unregister failed:", err);
    }
    try {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
      console.log("Cache cleared.");
    } catch (err) {
      console.warn("Cache clear failed:", err);
    }
    this.retryPageLoading();
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const chunkFailedMsg = /Loading chunk [\w-]+ failed/i;
    const chunkExecRefusedMsg = /Refused to execute script/i;
    const chunkLoadErrorMsg = /ChunkLoadError/i;

    console.log("ErrorBoundary caught:", error.message);
    // this.setState((prevState) => ({
    //   errorMessage: {
    //     ...(prevState.errorMessage ?? {}),
    //     componentStack: errorInfo?.componentStack || "",
    //   },
    // }));
    const isChunkError =
      chunkFailedMsg.test(error.message) ||
      chunkExecRefusedMsg.test(error.message) ||
      chunkLoadErrorMsg.test(error.message);

    if (isChunkError) {
      this.handleChunkError();
    }
  }

  // errorMessage is set here to avoid a second setState call in componentDidCatch
  static getDerivedStateFromError(error: Error) {
    return {
      error,
      errorMessage: {
        msg: error.message,
        stk: error.stack,
      },
    };
  }

  handleOpen = () => {
    this.clearError();
  };

  // This will render this component wherever called
  render() {
    return (
      <>
        {this.state.error ? (
          <APIFailurePopup
            open={true}
            handleOpen={this.handleOpen}
            errorFromUI={true}
            moduleName="UI-Error"
            pageName="ErrorBoundary"
            errorMessage={this.state.errorMessage}
          />
        ) : (
          this.props.children
        )}
      </>
    );
  }
}
export default ErrorBoundary;
